class Languages {
    constructor(el) {
        this.el = el
        this.active = this.el.querySelector('[data-languages--active]')
        this.others = this.el.querySelector('[data-languages--others]')

        this.bind()
    }

    bind() {
        this.onActiveClick = this.onActiveClick.bind(this)
        this.onClick = this.onClick.bind(this)

        this.active.addEventListener('click', this.onActiveClick)
        document.addEventListener('click', this.onClick)
    }

    unbind() {
        this.active.removeEventListener('click', this.onActiveClick)
        document.removeEventListener('click', this.onClick)
    }

    onActiveClick(e) {
        e.preventDefault()

        this[this.el.classList.contains('group-is-open') ? 'close' : 'open']()
    }

    onClick(e) {
        const isOutside = !Boolean(e.target.closest('[data-languages]'))

        if (!isOutside) { return }

        this.close()
    }

    close() {
        this.el.classList.remove('group-is-open')
    }

    open() {
        this.el.classList.add('group-is-open')
    }

    destroy() {
        this.unbind();
    }
}


export default {
    when() {
        return document.querySelectorAll('[data-languages]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-languages]').forEach(languages => {
            const instance = new Languages(languages)
            this.instances.push(instance);
        })
    },

    destroyed() {
        this.unbind();
    }
}
